import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AngularResizeEventModule } from 'angular-resize-event';
import { AvatarModule } from 'ngx-avatars';
import { NgxFileDropModule } from 'ngx-file-drop';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { DocumentFileItemComponent } from './components/document-file-item/document-file-item.component';
import { DocumentFilterPipe } from './components/document-filter.pipe';
import { DocumentFolderItemComponent } from './components/document-folder-item/document-folder-item.component';
import { DocumentInformationComponent } from './components/document-information/document-information.component';
import { ActivityTabComponent } from './components/document-information/tabs/activity-tab/activity-tab.component';
import { DetailsTabComponent } from './components/document-information/tabs/details-tab/details-tab.component';
import { DocumentListGridViewComponent } from './components/document-list-grid-view/document-list-grid-view.component';
import { DocumentListTableViewComponent } from './components/document-list-table-view/document-list-table-view.component';
import { DocumentListComponent } from './components/document-list/document-list.component';
import { EmptyListComponent } from './components/document-list/empty-list/empty-list.component';
import { DocumentNewFolderDialogComponent } from './components/document-new-folder-dialog/document-new-folder-dialog.component';
import { DocumentShareDialogComponent } from './components/document-share-dialog/document-share-dialog.component';
import { DocumentUploadBottomSheetComponent } from './components/document-upload-bottom-sheet/document-upload-bottom-sheet.component';
import { DocumentUploadQueueComponent } from './components/document-upload-queue/document-upload-queue.component';
import { ClickOutside } from './directives/click-outside.directive';
import { FileSizePipe } from './pipes/file-size.pipe';
import { DocumentTreeNodeComponent } from './components/document-tree-node/document-tree-node.component';
import { DocumentTreeViewComponent } from './components/document-tree-view/document-tree-view.component';
import { ShareViaEmailDialogComponent } from './components/document-share-dialog/share-via-email-dialog/share-via-email-dialog.component';
// Forms & Inputs
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

// Buttons & Indicators
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge'; // If needed
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRippleModule } from '@angular/material/core';

// Layout & Navigation
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';

// Popups & Modals
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';

// Data Table
import { MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { CdkTableModule } from '@angular/cdk/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { PlatformComponentsModule } from '@ecap3/app-platform-core-components';
// import { SharedDataModule } from 'src/app/shared-data';
import { NgModule } from '@angular/core';
import { AppLoaderModule } from 'src/app/fuse/app-loader/app-loader.module';
import { FeatherIconModule } from 'src/app/root/feather-icon.module';
// import { FileSaverModule } from 'ngx-filesaver';
import { DocumentService } from './services/document.service';
import { genericHttpLoaderFactory } from 'src/app/shared/providers/delta-uilm-provider';
import { AppSharedPipeModule } from 'src/app/app-shared-pipe/app-shared-pipe.module';

@NgModule({ declarations: [
        DocumentTreeNodeComponent,
        DocumentTreeViewComponent,
        DocumentListComponent,
        DocumentInformationComponent,
        DocumentFileItemComponent,
        DocumentFolderItemComponent,
        DocumentListGridViewComponent,
        DocumentListTableViewComponent,
        DetailsTabComponent,
        ActivityTabComponent,
        DocumentUploadBottomSheetComponent,
        DocumentUploadQueueComponent,
        DocumentNewFolderDialogComponent,
        EmptyListComponent,
        DocumentShareDialogComponent,
        DocumentFilterPipe,
        ClickOutside,
        FileSizePipe,
        ShareViaEmailDialogComponent
    ],
    exports: [
        DocumentTreeNodeComponent,
        DocumentTreeViewComponent,
        DocumentListComponent,
        DocumentInformationComponent,
        DocumentFileItemComponent,
        DocumentFolderItemComponent,
        DocumentListGridViewComponent,
        DocumentListTableViewComponent,
        DetailsTabComponent,
        ActivityTabComponent,
        DocumentUploadBottomSheetComponent,
        DocumentUploadQueueComponent,
        DocumentNewFolderDialogComponent,
        EmptyListComponent,
        DocumentShareDialogComponent,
        DocumentFilterPipe
    ], imports: [MatIconModule,
        MatTooltipModule,
        MatSidenavModule,
        MatTableModule,
        MatAutocompleteModule,
        CdkTableModule,
        MatGridListModule,
        MatListModule,
        MatFormFieldModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatChipsModule,
        MatButtonModule,
        MatInputModule,
        MatTabsModule,
        FlexLayoutModule,
        PlatformComponentsModule,
        AvatarModule,
        TranslateModule.forChild(),
        CommonModule,
        AngularResizeEventModule,
        MatBottomSheetModule,
        MatCardModule,
        NgxFileDropModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatMenuModule,
        MatDialogModule,
        MatSnackBarModule,
        AppLoaderModule,
        NgxLoadingModule.forRoot({
            animationType: ngxLoadingAnimationTypes.wanderingCubes,
            backdropBackgroundColour: 'rgba(0,0,0,0.1)',
            backdropBorderRadius: '4px',
            primaryColour: '#ffffff',
            secondaryColour: '#ffffff',
            tertiaryColour: '#ffffff'
        }),
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: genericHttpLoaderFactory(['generic-app']),
                deps: [HttpClient]
            },
            isolate: true
        }),
        MatRippleModule,
        // SharedDataModule,
        FeatherIconModule,
        AppSharedPipeModule], providers: [
        DocumentService,
    ] })
export class AppPlatformDocumentManagerModule { }
